// ============================================================================
// MarketDisputePage — СПОР ГЛАЗАМИ УЧАСТНИКА (заказчик/мастер).
// Открытие спора, история обсуждения, комментарии; решение показывает оператор.
// ============================================================================

import { useEffect, useState } from 'react';
import { MarketTopBar } from '@/components/market/MarketTopBar';
import { MarketDisputeView } from '@/components/market/MarketDisputeView';
import { marketRequestTitle, type MarketRequest } from '@/lib/market';
import { useAuthStore } from '@/store/authStore';
import { loadMarketMasterEntityId } from '@/lib/marketActions';
import { logSwallowed } from '@/lib/errors';
import { canOpenMarketDispute } from '@/lib/marketDispute';

interface MarketDisputePageProps {
  request: MarketRequest;
  onBack: () => void;
}

export function MarketDisputePage({ request, onBack }: MarketDisputePageProps) {
  const myId = String(useAuthStore((s) => s.user?.id || ''));
  const [masterUserId, setMasterUserId] = useState('');
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setChecked(false);
    if (!request.masterId || request.createdBy === myId) {
      setMasterUserId('');
      setChecked(true);
      return () => { cancelled = true; };
    }
    loadMarketMasterEntityId(request.masterId)
      .then((id) => { if (!cancelled) setMasterUserId(id || ''); })
      .catch((e) => logSwallowed(e, 'Спор маркетплейса: учётная запись мастера'))
      .finally(() => { if (!cancelled) setChecked(true); });
    return () => { cancelled = true; };
  }, [request.masterId, request.createdBy, myId]);

  const canOpen = checked && canOpenMarketDispute(request, myId, masterUserId);
  const title = marketRequestTitle(request);

  return (
    <div className="flex h-full flex-col bg-background text-foreground">
      <MarketTopBar
        title="Спор по заявке"
        subtitle={request.categoryName || title}
        onBack={onBack}
      />
      <div className="flex-1 overflow-y-auto">
        <div className="mx-auto w-full max-w-2xl p-4 pb-8 sm:p-6">
          <MarketDisputeView
            requestId={request.id}
            requestTitle={title}
            mode="participant"
            canOpen={canOpen}
          />
        </div>
      </div>
    </div>
  );
}
